
import React from 'react';
import BillAuditingPanel from '@/components/BillAuditingPanel';
import DataExtractionTool from '@/components/data-extraction/DataExtractionTool';
import InvoiceTable from '@/components/InvoiceTable';
import AnimatedCard from '@/components/ui/AnimatedCard';

const FinancialsReportsGrid = () => {
  return (
    <div className="grid grid-cols-1 gap-6 h-full p-4 overflow-y-auto max-h-[calc(100vh-150px)]">
      {/* Bill Auditing section */}
      <div className="h-auto">
        <div className="rounded-lg bg-white dark:bg-[#0B101C] border border-gray-200 dark:border-gray-800 shadow-sm hover:shadow-md transition-shadow overflow-hidden h-full">
          <BillAuditingPanel />
        </div>
      </div>
      
      {/* Invoice History section */}
      <AnimatedCard
        animation="fade-up"
        delay={300}
        className="border border-gray-200 dark:border-gray-800 shadow-sm hover:shadow-md transition-shadow rounded-xl bg-white dark:bg-gray-900 overflow-hidden min-h-[300px]"
      >
        <div className="p-4 h-full flex flex-col">
          <h3 className="text-lg font-semibold mb-2 text-gray-800 dark:text-white">Invoice History</h3>
          <div className="flex-1 min-h-0 overflow-hidden">
            <InvoiceTable />
          </div>
        </div>
      </AnimatedCard>
      
      {/* Data & Reports section */}
      <div className="h-auto">
        <div className="rounded-lg bg-white dark:bg-[#0B101C] border border-gray-200 dark:border-gray-800 shadow-sm hover:shadow-md transition-shadow overflow-hidden h-full">
          <DataExtractionTool />
        </div>
      </div>
    </div>
  );
};

export default FinancialsReportsGrid;
